import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'AppLoader',
  setup(__props) {

 const iconLoading = new URL('@/assets/image/icon-loading.svg', import.meta.url).href;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: _unref(iconLoading),
    width: "16",
    height: "16",
    class: "loading-image"
  }, null, 8, _hoisted_1))
}
}

})